// extracted by mini-css-extract-plugin
export default {"mobileBreakPoint":"780px","button":"button_button__vsi3z"};